"use strict";

var _regeneratorRuntime = require("/builds/Cimpress-Technology/ff/apps/ContractManagerV2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _fetchWithAuth = _interopRequireDefault(require("./fetchWithAuth"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var getProductData =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(_ref) {
    var productID, version, accessToken, route, product;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            productID = _ref.productID, version = _ref.version, accessToken = _ref.accessToken;
            route = "v1/products/".concat(productID, "/versions/").concat(version);

            if (version.toLowerCase() === 'current') {
              route = "v1/products/".concat(productID, ":current");
            }

            _context.prev = 3;
            _context.next = 6;
            return (0, _fetchWithAuth["default"])({
              route: route,
              accessToken: accessToken
            });

          case 6:
            product = _context.sent;
            _context.next = 15;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](3);
            route = "v1/products/".concat(productID, ":latest");
            _context.next = 14;
            return (0, _fetchWithAuth["default"])({
              route: route,
              accessToken: accessToken
            });

          case 14:
            product = _context.sent;

          case 15:
            return _context.abrupt("return", product);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 9]]);
  }));

  return function getProductData(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var _default = getProductData;
exports["default"] = _default;